import { bindActionCreators, compose } from 'redux';
import { connect, makeScrollable, QuizSession, addError, screenreaderNotification, pinSessionItem, interactionFileUpload, editResponse, previewResponse, openModal, generateImportModalId, featureOn, getActiveCalculatorId, setActiveCalculatorId, isTimeUp, getResponseDataByPosition } from '@instructure/quiz-core';
import { TakeItem as TakeItemPresenter } from './presenter';
export function mapStateToProps(state, ownProps) {
  var quizSessionId = ownProps.quizSessionId;
  var quizSession = QuizSession.create(state.getIn(['quizSessions', quizSessionId]));
  var allowBacktracking = quizSession.allowBacktracking;
  var isOneQuestionAtATime = quizSession.isOneQuestionAtATime();
  var showPin = quizSession.id && (allowBacktracking || !isOneQuestionAtATime);
  var position = ownProps.sessionItem.position;
  var isPinned = quizSession.pins().includes(position);
  var item = ownProps.sessionItem.getItem();
  return {
    activeCalculatorId: getActiveCalculatorId(state),
    allowClearMcSelection: quizSession.allowClearMcSelection,
    appContainer: state.getIn(['ui', 'appContainer']),
    choiceElimination: featureOn('choice_elimination') && quizSession.choiceElimination,
    displayValidationWarning: featureOn('invalid_input_warning'),
    isPinned: isPinned,
    item: item,
    pointsPossible: ownProps.sessionItem.pointsPossible,
    position: position,
    quizSessionId: quizSessionId,
    response: getResponseDataByPosition(state, position),
    scrollKey: ownProps.sessionItem.id,
    timeIsUp: isTimeUp(state),
    showPin: showPin
  };
}
export function mapDispatchToProps(dispatch) {
  return {
    addError: bindActionCreators(addError, dispatch),
    editResponse: bindActionCreators(editResponse, dispatch),
    interactionFileUpload: bindActionCreators(interactionFileUpload, dispatch),
    pinSessionItem: bindActionCreators(pinSessionItem, dispatch),
    previewResponse: bindActionCreators(previewResponse, dispatch),
    screenreaderNotification: bindActionCreators(screenreaderNotification, dispatch),
    setActiveCalculatorId: bindActionCreators(setActiveCalculatorId, dispatch),
    openImportModal: function openImportModal(importModalId) {
      dispatch(openModal(generateImportModalId(importModalId)));
    }
  };
}
export var TakeItem = compose(connect(mapStateToProps, mapDispatchToProps), makeScrollable)(TakeItemPresenter);
export default TakeItem;